import { blockOfflineAction } from '@/shared/utils';
import SDK from './core';

export const createGroup = async (name, members, groupImage) => {
   if (!blockOfflineAction()) {
      return await SDK.createGroup(name, members, groupImage);
   }
};
export const getGroupsList = async () => {
   if (!blockOfflineAction()) {
      return await SDK.getGroupsList();
   }
};
export const getGroupParticipants = async jid => {
   if (!blockOfflineAction()) {
      return await SDK.getGroupParticipants(jid);
   }
};
export const addParticipants = async (groupJid, groupName, members) => {
   if (!blockOfflineAction()) {
      return await SDK.addParticipants(groupJid, groupName, members);
   }
};
export const userDeleteGroup = async jid => {
   if (!blockOfflineAction()) {
      return await SDK.userDeleteGroup(jid);
   }
};
export const userExitGroup = async (groupJid, userJid) => {
   if (!blockOfflineAction()) {
      return await SDK.userExitGroup(groupJid, userJid);
   }
};
export const makeAsAdmin = async (groupJid, userJid) => {
   if (!blockOfflineAction()) {
      return await SDK.makeAsAdmin(groupJid, userJid);
   }
};

export const removeAdmin = async (groupJid, userJid) => {
   if (!blockOfflineAction()) {
      return await SDK.removeAdmin(groupJid, userJid);
   }
};

export const removeParticipant = async (groupJid, userJid) => {
   if (!blockOfflineAction()) {
      return await SDK.removeParticipant(groupJid, userJid);
   }
};
export const setGroupProfile = async (groupJid, name, image) => {
   if (!blockOfflineAction()) {
      return await SDK.setGroupProfile(groupJid, name, image);
   }
};
